<template>
    <div class="row">
        <!-- Khóa học đã chọn -->
        <div class="example-preview table-responsive">
            <h4 class="mb-3" style="font-weight: 700">Khóa học đã chọn</h4>
            <b-button id="button_show_value" v-b-toggle.list-chosen-courses class="m-1 m-0 show-inf" variant="success"
                      @click="changeChervon">
                Chi tiết khóa học <i class="fas fa-chevron-down"></i>
            </b-button>
            <b-collapse id="list-chosen-courses">
                <table class="table table-vertical-center">
                    <tbody>
                    <tr v-for="(course_info,index) in contract.student_register_courses" :key="index">
                        <td>{{ course_info.course.name }}</td>
                        <td v-if="!hideCoursePriceEdit" width="25%">
                            <input v-model="coursePrice[index]" class="form-control input-course"
                                   type="number" v-on:input="changeCoursePrice(index)">
                        </td>
                        <td>{{ course_info.course_sale }} %</td>
                        <td>
                            {{
                                parseInt(course_info.course_fee) * (1 - parseInt(course_info.course_sale) / 100) | toThousandFilter
                            }}
                            ₫
                        </td>
                    </tr>
                    </tbody>
                </table>
            </b-collapse>
            <div class="row pt-1">
                <div class="col-md-6">
                    <strong class="pl-2">Tổng giá khóa (1)</strong>
                </div>
                <div class="col-md-6 text-right">
                    <strong>{{ totalCourseRegisterFee | toThousandFilter }} ₫</strong>
                </div>
            </div>
        </div>
        <!-- Chi tiết thanh toán -->
        <div class="payment-detail pt-5">
            <div>
                <h4 class="mb-3" style="font-weight: 700">Chi tiết thanh toán</h4>
            </div>
            <b-button v-b-toggle.payment-contract-detail class="m-1 m-0 button_show_value show-inf" variant="success"
                      @click="changeChervonPromotion">
                Chi tiết khuyến mại <i class="fas fa-chevron-down"></i>
            </b-button>
            <b-collapse id="payment-contract-detail">
                <div v-for="(voucher,index) in vouchersForContract" v-if="vouchersForContract.length > 0" :key="index"
                     class="row" style="padding: 0.75rem">
                    <div class="col-4">
                        <p>Voucher {{ ++index }}:</p>
                    </div>
                    <div class="col-4">
                        <!-- Giảm giá mã Km -->
                        <span v-if="voucher.type !== 0"
                              class="promotion-list"><strong>{{ 'Quy đổi quà tặng - ' + voucher.name }}</strong></span>
                        <span v-else class="promotion-list"><strong>{{ voucher.name }}</strong></span>
                    </div>
                    <div class="col-4">
                        <strong v-if="voucher.unit === 1 " class="text-danger">{{ voucher.value | toThousandFilter }}
                            ₫</strong>
                        <strong v-else class="text-danger">{{ voucher.value }} %</strong>
                    </div>
                </div>
            </b-collapse>
            <div class="row pt-3 px-3">
                <div class="col-md-6 pb-2">
                    <strong>Tổng khuyến mại (2)</strong>
                </div>
                <div class="col-md-6 pb-2 text-right">
                    <strong>{{ totalDiscount | toThousandFilter }} ₫</strong>
                </div>
            </div>

            <!-- Gói dịch vụ bảo hành -->
            <div v-if="isShowWarrantySummary" class="row pb-3 mt-1 px-3">
                <div class="col-12 pb-2">
                    <strong>Gói dịch vụ bảo hành</strong>
                </div>
                <div class="col-md-8 d-flex align-items-center">
                    <i class="el-icon-menu mr-2"></i>
                    <strong>{{ contract.service.name }}</strong>
                </div>
                <div class="col-md-4 text-right">
                    <strong>{{ warrantyServiceAmount | formatVND }}</strong>
                </div>
            </div>
            <div class="row px-3">
                <div v-if="totalDestroyFee > 0" class="col-md-6 pb-2">
                    <strong>Phí hủy khóa <span>(3)</span></strong>
                </div>
                <div v-if="totalDestroyFee > 0" class="col-md-6 text-right">
                    <strong>{{ totalDestroyFee | toThousandFilter }} ₫</strong>
                </div>
                <div v-if="isTransferred" class="col-md-6 pb-2">
                    <strong>Khuyến mại sau thay đổi</strong>
                </div>
                <div v-if="isTransferred && isWithdrawWithCourse" class="col-md-6 text-right">
                    <strong>{{ totalPromotionAfterTransferred | toThousandFilter }} ₫</strong>
                </div>
            </div>

            <hr v-if="isWithdrawWithCourse" class="hr">

            <div class="row p-3">
                <div class="col-md-8 pb-2 d-flex">
                    <strong>Tổng giá trị hợp đồng
                        <span> {{ totalDestroyFee > 0 ? '(4)' : '(3)' }}
                            <i v-tooltip="'(5) = (1) - (3) - (4) + (5)'" class="fas fa-info-circle"
                               style="cursor: pointer; color: #3a8ee6"></i>
                        </span>
                    </strong>
                    <span @click="collapse_detail = !collapse_detail">
                        <i :class="{'fa-chevron-down': !collapse_detail, 'fa-chevron-up': collapse_detail}"
                           class="fas pl-2"
                           style="cursor: pointer;  font-size: 12px;"></i>
                    </span>
                </div>
                <div class="col-md-4  pb-2 text-right">
                    <strong>{{ totalPriceContract | toThousandFilter }} ₫</strong>
                </div>
                <div v-if="collapse_detail" class="col-md-12 pb-2 mt-2">
                    <div>Giá khoá học sau khuyến mại</div>
                    <div>
                        <ul class="ml-6">
                            <li v-for="(course_info, index) in courseList" :key="index">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div> {{ course_info.course.name }}</div>
                                    <div class="pr-6 pl-2 py-2 border bg-white my-1"
                                         style="width: 50%; border-radius: 6px; text-align: right">
                                        {{ course_info.course_fee_discount_proxy | toThousandFilter }} ₫
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 text-center">
                    <strong>Đã thanh toán
                        <span>{{ totalDestroyFee > 0 ? '(5)' : '(4)' }}</span>
                    </strong>
                </div>
                <div class="col-md-6 text-right">
                    <strong>{{ totalPaidAmount | toThousandFilter }} ₫</strong>
                </div>

                <div class="col-md-6 pt-2">
                    <strong>Còn nợ
                        <span v-if="isWithdrawWithCourse"> {{ totalDestroyFee > 0 ? '(6)' : '(5)' }}
                            <i v-tooltip="'(8) = (6) - (7)'" class="fas fa-info-circle"
                               style="cursor: pointer; color: #3a8ee6"></i>
                        </span>
                    </strong>
                </div>
                <div class="col-md-6 pt-2 text-right">
                    <strong>{{ remainingDebtAmount | toThousandFilter }} ₫</strong>
                </div>
            </div>

        </div>

        <!-- Quà tặng -->
        <div v-if="is_edutalk && gift_select.length" class="payment-detail pt-5 table-responsive">
            <div>
                <h4 class="mb-3" style="font-weight: 700">Quà tặng</h4>
            </div>
            <div v-for="gift in gift_select" :key="gift.id" class="d-flex align-items-center mb-2" >
                <div class="w-100">
                    <b-button :id="`gift-${gift.id}`" v-b-toggle="`payment-gift-detail-${gift.id}`" class="m-1 m-0 button_show_value" >
                        {{ gift.name }} <i class="fas fa-chevron-down"></i>
                    </b-button>
                    <b-collapse :id="`payment-gift-detail-${gift.id}`">
                        <p class="mt-3 pl-2 ml-3 font-weight-bold" v-html="gift.description"></p>
                    </b-collapse>
                </div>
            </div>
        </div>
        <list-course-refund :list-courses-refund="coursesRefund" :show-modal="showModalListCourses" @clicked="closeModalListCourses"></list-course-refund>
    </div>
</template>

<script>
import ListCourseRefund from "./ListCourseRefund";
import {isWarrantyServiceCenter} from "@/core/config/center/centerOption";

export default {
    name: "PaymentDetailNapRutForm",
    components: {
        ListCourseRefund
    },
    props: {
        contract: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isWithdrawWithCourse: {
            default: false
        },
        promotionForContract: {
            type: [Object, String],
            default: () => {
                return ''
            }
        },
        vouchersForContract: {
            type: Array,
            default: () => {
                return []
            }
        },
        coursePrice: {
            type: [Array],
            default: () => {
                return []
            }
        },
        hideCoursePriceEdit: {
            type: Boolean,
            default: false,
        },
        promotions: {
            type: [Array],
            default: () => {
                return []
            }
        },
        vouchers: {
            type: [Array],
            default: () => {
                return []
            }
        },
        totalDiscount: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalCourseRefundFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalDestroyFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalCourseRegisterFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalContractAmount: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        coursesRefund: {
            type: [Array],
            default: () => {
                return []
            }
        },
        tongKhuyenMaiSauHuy: {
            type: Number,
            default: 0
        },
        isTransferred: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        totalPromotionAfterTransferred: {
            type: Number,
            default: () => {
                return 0
            }
        },
        is_edutalk: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        gift_select: {
            type: Array,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            showModalListCourses: false,
            collapse_detail: false,
        }
    },
    computed: {
        isShowWarrantySummary() {
            return isWarrantyServiceCenter(this.contract.center_id) && !!this.contract.service_id;
        },
        warrantyServiceAmount() {
            const serviceTotal = Number(this.contract.service_total);

            if (serviceTotal > 0) {
                return serviceTotal;
            }

            if (!this.contract.service) {
                return 0;
            }

            const total = Number(this.contract.total) || 0;
            const percent = Number(
                this.contract.service.percent_price != null
                    ? this.contract.service.percent_price
                    : this.contract.service.percent
            ) || 0;

            return (total * percent) / 100;
        },
        totalPriceContract() {
            return this.totalCourseRegisterFee - this.totalDiscount + this.totalDestroyFee + this.contract.service_total;
        },
        totalPaidAmount() {
            return (Number(this.contract.total_paid) || 0);
        },
        remainingDebtAmount() {
            return (Number(this.totalPriceContract) || 0)
                - this.totalPaidAmount;
        },
        courseList() {
            const self = this;
            const destroy_fee = self.totalDestroyFee;
            const totalContract = this.totalCourseRegisterFee - this.totalDiscount + this.totalDestroyFee;
            const totalCourseFeeDiscount = this.contract.student_register_courses.reduce((sum, item) => sum + item.course_fee_discount, 0);
            return this.contract.student_register_courses.map(course_info => ({
                ...course_info,
                get course_fee_discount_proxy() {
                    if (totalCourseFeeDiscount !== totalContract) {
                        let percent = parseInt(course_info.course_fee) / self.totalCourseRegisterFee;
                        if (destroy_fee > 0) {
                            return parseInt(course_info.course_fee) - parseInt(percent * self.totalDiscount) + parseInt(percent * destroy_fee);
                        }
                        return parseInt(course_info.course_fee) - (percent) * self.totalDiscount;
                    } else {
                        return parseInt(course_info.course_fee_discount);
                    }
                },
                set course_fee_discount_proxy(val) {
                    course_info.course_fee_discount = val;
                }
            }));
        }
    },
    methods: {
        calculatorCourse(course, total, totalVoucher) {
            return course - parseInt((course / total) * totalVoucher)
        },
        changeCoursePrice(index) {
            this.$emit('changeCoursePrice', index);
        },
        changeChervon() {
            $('#button_show_value').children('.fas').toggleClass('fa-chevron-up fa-chevron-down');
        },
        changeChervonPromotion() {
            $('.button_show_value').children('.fas').toggleClass('fa-chevron-up fa-chevron-down');
        },
        openModalListCourses: function () {
            this.showModalListCourses = true;
        },
        closeModalListCourses: function () {
            this.showModalListCourses = false;
        },
    }
}
</script>

<style scoped>

</style>
